"use client";

import { useId } from "react";
import { usePortalTranslations } from "../i18n/client";
import styles from "./PortalSectionAccessState.module.css";

export function PortalSectionAccessState({ sectionTitle, reviews, loginHref, accessHref, eligibilityHref, homeHref }: { sectionTitle: string; reviews: boolean; loginHref?: string; accessHref?: string; eligibilityHref?: string; homeHref: string }) {
  const t = usePortalTranslations();
  const headingId = useId();
  const title = loginHref
    ? t(reviews ? "portal.unavailable.reviewsSignInTitle" : "portal.unavailable.signInTitle")
    : t(accessHref ? "portal.unavailable.membershipTitle" : eligibilityHref ? "portal.unavailable.eligibilityTitle" : "portal.unavailable.title");
  const description = loginHref
    ? t(reviews ? "portal.unavailable.reviewsSignInDescription" : "portal.unavailable.signInDescription")
    : t(accessHref ? "portal.unavailable.membershipDescription" : eligibilityHref ? "portal.unavailable.eligibilityDescription" : "portal.unavailable.description");
  const actionHref = loginHref ?? accessHref ?? eligibilityHref;
  const actionLabel = loginHref ? t("portal.login") : t(accessHref ? "portal.unavailable.membershipAction" : "portal.unavailable.eligibilityAction");

  return <section className={styles.panel} aria-labelledby={headingId}>
    <p className={styles.context}>{sectionTitle}</p>
    <h1 className={styles.title} id={headingId}>{title}</h1>
    <p className={styles.description}>{description}</p>
    <div className={styles.actions}>
      {actionHref ? <a className={styles.primary} href={actionHref}>
        {actionLabel}
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12h14m-6-6 6 6-6 6" /></svg>
      </a> : null}
      <a className={actionHref ? styles.secondary : styles.primary} href={homeHref}>{t("portal.navigation.backToOverview")}</a>
    </div>
  </section>;
}
